module.exports = __webpack_public_path__ + "img/PUBLICACIONESWEB.f450daff.svg";